import axios from 'axios';
import qs from 'qs';
import { get } from 'lodash';

const INCOMINGSMS_LIST_LOAD = 'INCOMINGSMS_LIST_LOAD';
const INCOMINGSMS_LIST_SUCCESS = 'INCOMINGSMS_LIST_SUCCESS';
const INCOMINGSMS_LIST_FAILED = 'INCOMINGSMS_LIST_FAILED';
const INCOMINGSMS_SET_LOADING = 'INCOMINGSMS_SET_LOADING';

const INCOMINGSMS_FORM_LOAD = 'INCOMINGSMS_FORM_LOAD';
const INCOMINGSMS_FORM_SUCCESS = 'INCOMINGSMS_FORM_SUCCESS';
const INCOMINGSMS_FORM_FAILED = 'INCOMINGSMS_FORM_FAILED';

const INCOMINGSMS_DELETE_LOAD = 'INCOMINGSMS_DELETE_LOAD';
const INCOMINGSMS_DELETE_SUCCESS = 'INCOMINGSMS_DELETE_SUCCESS';
const INCOMINGSMS_DELETE_FAILED = 'INCOMINGSMS_DELETE_FAILED';

const INCOMINGSMS_EDIT_LOAD = 'INCOMINGSMS_EDIT_LOAD';
const INCOMINGSMS_EDIT_SUCCESS = 'INCOMINGSMS_EDIT_SUCCESS';
const INCOMINGSMS_EDIT_FAILED = 'INCOMINGSMS_EDIT_FAILED';

const INCOMINGSMS_VIEW_LOAD = 'INCOMINGSMS_VIEW_LOAD';
const INCOMINGSMS_VIEW_SUCCESS = 'INCOMINGSMS_VIEW_SUCCESS';
const INCOMINGSMS_VIEW_FAILED = 'INCOMINGSMS_VIEW_FAILED';

const INCOMINGSMS_RESET = 'INCOMINGSMS_RESET';

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit:process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: '',
  orderMode: 'ASC',
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INCOMINGSMS_RESET:
      return {
        ...initialState
      };
    case INCOMINGSMS_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case INCOMINGSMS_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false
      };
    case INCOMINGSMS_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case INCOMINGSMS_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case INCOMINGSMS_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case INCOMINGSMS_FORM_FAILED:
    case INCOMINGSMS_EDIT_FAILED:
    case INCOMINGSMS_DELETE_FAILED:
    case INCOMINGSMS_LIST_FAILED:
    case INCOMINGSMS_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case INCOMINGSMS_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode
      };
      case INCOMINGSMS_VIEW_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            failed: false,
            viewData: action.viewData,
            viewLoading: false
        };
    case INCOMINGSMS_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case INCOMINGSMS_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case INCOMINGSMS_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case INCOMINGSMS_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
}

export const reset = () => dispatch => {
  dispatch({
    type: INCOMINGSMS_RESET
  });
};

export const updateIncomingSms = (model,id,data) => dispatch => {
  dispatch({
    type: INCOMINGSMS_EDIT_LOAD
  });

    let obj = {};
    obj[model] = data;

  return axios.put('/v1/incoming-sms-messages/'+id, obj).then(
      () => dispatch({
        type: INCOMINGSMS_EDIT_SUCCESS
      })
  ).catch(error => {
    dispatch({
      type: INCOMINGSMS_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const viewIncomingSms = (id) => dispatch => {
    dispatch({
        type: INCOMINGSMS_VIEW_LOAD
    });
    return axios.get('/v1/incoming-sms-messages/'+id).then(
        response => dispatch({
            type: INCOMINGSMS_VIEW_SUCCESS,
            viewData: get(response, 'data.data'),
            commentThread: get(response, 'data.commentThread', false)
        })
    ).catch(error => {
        dispatch({
            type: INCOMINGSMS_VIEW_FAILED,
            message: get(error, 'response.data.message', null)
        })
    });
};

export const createIncomingSms = (model, data) => dispatch => {
  dispatch({
    type: INCOMINGSMS_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios.post('/v1/incoming-sms-messages', obj).then(response => dispatch({
    type: INCOMINGSMS_EDIT_SUCCESS,
    id: get(response, 'data.data.id', null),
  })).catch(error => {
    dispatch({
      type: INCOMINGSMS_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const incomingSmsDelete = (id) => dispatch => {
  dispatch({
    type: INCOMINGSMS_DELETE_LOAD
  });
  return axios.delete('/v1/incoming-sms-messages/'+id)
      .then((response) => dispatch({
        type: INCOMINGSMS_DELETE_SUCCESS,
        id
      })).catch(error => dispatch({
        type: INCOMINGSMS_DELETE_FAILED,
        message: get(error, 'response.data.message', null)
      }));
};

export const setLoading = (loading) => dispatch => {
  dispatch({
    type: INCOMINGSMS_SET_LOADING,
    loading
  });
};

export const incomingSmsList = (page, keyword, sort, filters, perPage) => dispatch => {
  dispatch({
    type: INCOMINGSMS_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    'per-page': perPage
  };

  params[filters.model] = filters.filters;

  return axios.get(
      '/v1/incoming-sms-messages',
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
  ).then(response => {
    let sort = get(response, 'data.sort', null),
        mode = 'ASC';
    if(sort && sort.indexOf('-') !== -1) {
      mode = 'DESC';
      sort = sort.substr(1);
    }
    return dispatch({
      type: INCOMINGSMS_LIST_SUCCESS,
      data: get(response, 'data.data', null),
      page: get(response, 'data.page', 0),
      limit: get(response, 'data.per-page', 0),
      total: get(response, 'data.total', 0),
      order: sort,
      orderMode: mode
    });
  })
  .catch(error => dispatch({
    type: INCOMINGSMS_LIST_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};



// WEBPACK FOOTER //
// ./src/redux/modules/incoming-sms.js